/**
 * MassRole - Role para conversão de unidades de massa
 *
 * Implementa os 4 pilares via SimpleRole base class.
 * Para uso funcional, prefira importar dos pilares diretamente.
 *
 * @example
 * // OOP style
 * import { massRole } from '@attrx/role-morphic/mass';
 * massRole.convert('kilogram', 'pound', 1);  // 2.20462
 *
 * // Functional style (preferido)
 * import { convertMass } from '@attrx/role-morphic/mass/convert';
 * convertMass('kilogram', 'pound', 1);  // 2.20462
 */

import { SimpleRole, type SimpleValidationConfig } from "../../contracts";
import { MASS_UNITS, MASS_ALIASES } from "./constants";

// =============================================================================
// MASS ROLE CLASS
// =============================================================================

export class MassRole extends SimpleRole {
  readonly name = "mass";
  readonly base = "kilogram";
  readonly units = MASS_UNITS;
  readonly aliases = MASS_ALIASES;

  readonly validation: SimpleValidationConfig = {
    min: 0,
    minError: "Mass cannot be negative",
  };
}

// =============================================================================
// SINGLETON INSTANCE
// =============================================================================

/** Instância singleton da MassRole */
export const massRole = new MassRole();
